import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_TEAMSPONSORS,
  SET_ERROR,
  SET_TEAMSPONSORS,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  sponsors: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEAMSPONSORS:
      return {
        ...state,
        isReady: true,
        isError: false,
        sponsors: action.data,
      };
    case RESET_TEAMSPONSORS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectTeamSponsors = createSelector(getState, (n) => n.sponsors);

reducerRegistry.register(REDUCER_NAME, reducer);
